import Icon from '@ant-design/icons';

// 1. RAW SVG DEFINITIONS (Remix Icon Paths)
/** Remix Icon: `alarm-warning-line` */
function AlarmWarningSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="1em"
      width="1em"
      viewBox="0 0 24 24"
    >
      <path d="M4.00001 20V14C4.00001 9.58172 7.58173 6 12 6C16.4183 6 20 9.58172 20 14V20H21V22H3.00001V20H4.00001ZM6.00001 20H18V14C18 10.6863 15.3137 8 12 8C8.6863 8 6.00001 10.6863 6.00001 14V20ZM11 2H13V5H11V2ZM19.7782 4.80761L21.1924 6.22183L19.0711 8.34315L17.6569 6.92893L19.7782 4.80761ZM2.80762 6.22183L4.22183 4.80761L6.34315 6.92893L4.92894 8.34315L2.80762 6.22183ZM7.00001 14C7.00001 11.2386 9.23858 9 12 9V11C10.3432 11 9.00001 12.3431 9.00001 14H7.00001Z" />
    </svg>
  );
}

/** Remix Icon: `door-closed-line` */
function DoorClosedSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="1em"
      width="1em"
      viewBox="0 0 24 24"
    >
      <path d="M2.99805 21V19H4.99805V4C4.99805 3.44772 5.44576 3 5.99805 3H17.998C18.5503 3 18.998 3.44772 18.998 4V19H20.998V21H2.99805ZM16.998 5H6.99805V19H16.998V5ZM14.998 11V13H12.998V11H14.998Z" />
    </svg>
  );
}

/** Remix Icon: `door-open-line` */
function DoorOpenSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="1em"
      width="1em"
      viewBox="0 0 24 24"
    >
      <path d="M1.99805 21.0001V19.0001L3.99805 18.9999V4.83465C3.99805 4.35136 4.34367 3.93723 4.81916 3.85078L14.2907 2.12868C14.6167 2.0694 14.9291 2.28564 14.9884 2.61167C14.9948 2.64708 14.998 2.68301 14.998 2.719V3.9999L18.998 4.00007C19.5503 4.00007 19.998 4.44779 19.998 5.00007V18.9999L21.998 19.0001V21.0001H17.998V6.00007L14.998 5.9999V21.0001H1.99805ZM12.998 4.3965L5.99805 5.66923V19.0001H12.998V4.3965ZM11.998 11.0001V13.0001H9.99805V11.0001H11.998Z" />
    </svg>
  );
}

/** Remix Icon: `refresh-line` */
function RefreshSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="1em"
      width="1em"
      viewBox="0 0 24 24"
    >
      <path d="M5.46257 4.43262C7.21556 2.91688 9.5007 2 12 2C17.5228 2 22 6.47715 22 12C22 14.1361 21.3302 16.1158 20.1892 17.7406L17 12H20C20 7.58172 16.4183 4 12 4C9.84982 4 7.89777 4.84827 6.46023 6.22842L5.46257 4.43262ZM18.5374 19.5674C16.7844 21.0831 14.4993 22 12 22C6.47715 22 2 17.5228 2 12C2 9.86386 2.66979 7.88416 3.8108 6.25944L7 12H4C4 16.4183 7.58172 20 12 20C14.1502 20 16.1022 19.1517 17.5398 17.7716L18.5374 19.5674Z" />
    </svg>
  );
}

/** Remix Icon: `signal-cellular-off-line` */
function SignalCellularOffSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      height="1em"
      width="1em"
      viewBox="0 0 24 24"
    >
      <path d="M22.207 20.793L20.793 22.207L19.5859 21H16V17.4141L15 16.4141V21H9V10.4141L1.79297 3.20703L3.20703 1.79297L22.207 20.793ZM8 21H2V13H8V21ZM4 19H6V15H4V19ZM11 19H13V14.4141L11 12.4141V19ZM22 17.7578L20 15.7578V5H18V13.7578L16 11.7578V3H22V17.7578ZM15 10.7578L12.2422 8H15V10.7578Z" />
    </svg>
  );
}

// 2. EXPORT AS ANTD-COMPATIBLE ICONS
export function AlarmWarningLine(props) {
  return <Icon component={AlarmWarningSvg} {...props} />;
}

export function DoorClosedLine(props) {
  return <Icon component={DoorClosedSvg} {...props} />;
}

export function DoorOpenLine(props) {
  return <Icon component={DoorOpenSvg} {...props} />;
}

export function RefreshLine(props) {
  return <Icon component={RefreshSvg} {...props} />;
}

export function SignalCellularOffLine(props) {
  return <Icon component={SignalCellularOffSvg} {...props} />;
}
